import React from 'react';
import {
  Alert, AlertDescription, AlertIcon, Box, Button, Flex, Text,
} from '@chakra-ui/react';
import StatusAlert from '../ElementaryComponents/StatusAlert';
import {
  NAVY, Panel, StepFooter, navyPress,
} from './TenantAccessLayout';

const RoleTab = ({
  apps,
  isFetching,
  isError,
  error,
  appRoles,
  onRole,
  canContinue,
  onBack,
  onContinue,
}) => {
  let body = null;
  if (isFetching) {
    body = <StatusAlert status="loading" alert_title="Loading app roles" />;
  } else if (isError) {
    body = <StatusAlert status="error" alert_title="Could not load app roles" error={error} />;
  } else {
    body = (
      <Flex direction="column" gap={3}>
        {(apps || []).map((app) => {
          const current = appRoles[app.name] || '';
          const options = [{ value: '', label: 'Don’t assign' }].concat(
            app.roles.map((role) => ({ value: role, label: role })),
          );
          return (
            <Flex
              key={app.name}
              borderWidth="1px"
              borderColor={current ? 'blue.500' : 'gray.300'}
              bg={current ? 'blue.50' : 'white'}
              borderRadius="md"
              p={3}
              gap={4}
              align="center"
              wrap="wrap"
            >
              <Box flex="1" minW="170px">
                <Text fontWeight="600">{app.name}</Text>
                <Text fontSize="xs" color="gray.600">{current ? `Assign as ${current}` : 'Not changing'}</Text>
              </Box>
              <Flex role="radiogroup" aria-label={`${app.name} role`} borderWidth="1px" borderRadius="md" p={1} bg="white" wrap="wrap">
                {options.map((option) => {
                  const on = current === option.value;
                  return (
                    <Button
                      key={option.label}
                      size="sm"
                      role="radio"
                      aria-checked={on}
                      variant={on ? 'solid' : 'ghost'}
                      colorScheme="blue"
                      color={on ? NAVY : undefined}
                      {...navyPress}
                      onClick={() => onRole(app.name, option.value)}
                    >
                      {option.label}
                    </Button>
                  );
                })}
              </Flex>
            </Flex>
          );
        })}
      </Flex>
    );
  }

  return (
    <Panel
      title="Which app roles should they have?"
      subtitle="Pick one role for each app they need access to."
      footer={(
        <StepFooter
          showBack
          hint={canContinue ? '' : 'Choose a role for at least one app to continue.'}
          canContinue={canContinue}
          onBack={onBack}
          onContinue={onContinue}
        />
      )}
    >
      {body}
      <Alert status="info" borderRadius="md">
        <AlertIcon />
        <AlertDescription>
          Each role you pick applies to every selected user in every selected tenant.
          If someone already has a different role in that app, it changes to this one.
          Apps left on “Don’t assign” aren’t touched. You’ll see exactly who changes
          on the next step.
        </AlertDescription>
      </Alert>
    </Panel>
  );
};

export default RoleTab;
